import React from 'react';
import PropTypes from 'prop-types';
import mergeWith from 'lodash/mergeWith';

import HorizontalForm from 'components/form/horizontal_form';
import { defaultProperty, yesNoOptions, constructionStatusOptions, parkingTypeOptions,
  conditionOptions, broadbandOptions, retailClienteleTypes, lotStabilizationOptions,
  lotBorderTypeOptions, servedRailProviderOptions, availableRailProviderOptions,
  tenancyIdOptions } from './assignment_constants';

export default class BuildingInfoSection extends React.Component {
  static propTypes = {
    buildingClasses: PropTypes.array.isRequired,
    property: PropTypes.object,
    onChange: PropTypes.func.isRequired
  }

  state = {
    expanded: false
  }

  toggleExpand = () => {
    this.setState((prevState) => {
      return { expanded: !prevState.expanded };
    });
  }

  renderAdditionalFields() {
    if (!this.state.expanded) return;

    const property = mergeWith(defaultProperty, this.props.property);

    return (
      <div className="mt-4">
        <HorizontalForm.TextInput
          label='Overhead Door Height (ft)'
          name='overheadDoorHeight'
          number
          value={property.overheadDoorHeight}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Gross Leasable Area (SF)'
          name='grossBuildingArea'
          number
          value={property.grossBuildingArea}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='loadFactor'
          number
          value={property.loadFactor}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          includeBlank
          label='Construction Status'
          name='constructionStatusId'
          options={constructionStatusOptions}
          value={property.constructionStatusId}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Parking Price ($/month/car)'
          name='parkingPricePerMonth'
          number
          value={property.parkingPricePerMonth}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          includeBlank
          name='parkingType'
          options={parkingTypeOptions}
          value={property.parkingType}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='laundryDescription'
          value={property.laundryDescription}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='plumbingDescription'
          value={property.plumbingDescription}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextArea
          name='exteriorDescription'
          value={property.exteriorDescription || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextArea
          name='interiorDescription'
          value={property.interiorDescription || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          name='sprinklers'
          options={yesNoOptions}
          value={property.sprinklers || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          name='trailerParking'
          options={yesNoOptions}
          value={property.trailerParking || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Warehouse %'
          name='warehousePct'
          number
          value={property.warehousePct}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='framing'
          value={property.framing}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          includeBlank
          name='condition'
          options={conditionOptions}
          value={property.condition}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          name='securityGuard'
          options={yesNoOptions}
          value={property.securityGuard || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          name='handicapAccess'
          options={yesNoOptions}
          value={property.handicapAccess || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          name='freightElevator'
          options={yesNoOptions}
          value={property.freightElevator || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='numberOfElevators'
          number
          value={property.numberOfElevators}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='numberOfEscalators'
          number
          value={property.numberOfEscalators}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          label='Central HVAC'
          name='centralHvac'
          options={yesNoOptions}
          value={property.centralHvac || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          includeBlank
          name='broadband'
          options={broadbandOptions}
          value={property.broadband}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          name='centrixEquipped'
          options={yesNoOptions}
          value={property.centrixEquipped || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='roof'
          value={property.roof}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          name='freeStanding'
          options={yesNoOptions}
          value={property.freeStanding || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          name='leedCertified'
          options={yesNoOptions}
          value={property.leedCertified || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          includeBlank
          name='retailClientele'
          options={retailClienteleTypes}
          value={property.retailClientele}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='numberOfBuildings'
          number
          value={property.numberOfBuildings}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextArea
          name='constructionDescription'
          value={property.constructionDescription || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='walls'
          value={property.walls}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='ceilings'
          value={property.ceilings}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='floorCoverings'
          value={property.floorCoverings}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='restrooms'
          value={property.restrooms}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='landscaping'
          value={property.landscaping}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='corridors'
          value={property.corridors}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='HVAC'
          name='hvac'
          value={property.hvac}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='foundation'
          value={property.foundation}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='elevators'
          value={property.elevators}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='exteriorWalls'
          value={property.exteriorWalls}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='mezzanine'
          value={property.mezzanine}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='officeBuildout'
          value={property.officeBuildout}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextArea
          name='parkingDescription'
          value={property.parkingDescription || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextArea
          name='utilitiesDescription'
          value={property.utilitiesDescription || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextArea
          name='loadingDescription'
          value={property.loadingDescription || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Min Crane Capacity (Tons)'
          name='minCraneCapacity'
          number
          value={property.minCraneCapacity}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Min Hook Height (Feet)'
          name='minHookHeight'
          number
          value={property.minHookHeight}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Checkbox
          name='served'
          value={property.served}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='numberOfBridgeCranes'
          number
          value={property.numberOfBridgeCranes}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Min Bridge Capacity (Tons)'
          name='minBridgeCraneCapacity'
          number
          value={property.minBridgeCraneCapacity}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Max Bridge Capacity (Tons)'
          name='maxBridgeCraneCapacity'
          number
          value={property.maxBridgeCraneCapacity}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Max Bridge Crane Span (ft)'
          name='maxBridgeCraneSpan'
          number
          value={property.maxBridgeCraneSpan}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextArea
          name='bridgeCraneDescription'
          value={property.bridgeCraneDescription || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='numberOfJibCranes'
          number
          value={property.numberOfJibCranes}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Min Jib Capacity (Tons)'
          name='minJibCraneCapacity'
          number
          value={property.minJibCraneCapacity}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Max Jib Capacity (Tons)'
          name='maxJibCraneCapacity'
          number
          value={property.maxJibCraneCapacity}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Jib Crane Span (ft)'
          name='jibCraneSpan'
          number
          value={property.jibCraneSpan}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Checkbox
          name='ready'
          value={property.ready}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Min Ready Capacity (Tons)'
          name='minReadyCraneCapacity'
          number
          value={property.minReadyCraneCapacity}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Max Ready Capacity (Tons)'
          name='maxReadyCraneCapacity'
          number
          value={property.maxReadyCraneCapacity}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Max Ready Crane Span (ft)'
          name='maxReadyCraneSpan'
          number
          value={property.maxReadyCraneSpan}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          includeBlank
          name='lotStabilization'
          options={lotStabilizationOptions}
          value={property.lotStabilization}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          includeBlank
          name='lotBorderType'
          options={lotBorderTypeOptions}
          value={property.lotBorderType}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Checkbox
          name='driveThroughAccess'
          value={property.driveThroughAccess}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          includeBlank
          name='servedRailProvider'
          options={servedRailProviderOptions}
          value={property.servedRailProvider}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          includeBlank
          name='availableRailProvider'
          options={availableRailProviderOptions}
          value={property.availableRailProvider}
          onChange={this.props.onChange}
        />
      </div>
    );
  }

  render() {
    const { property } = this.props;
    return (
      <React.Fragment>
        <h6 className="mb-2">Building Information</h6>
        <HorizontalForm.TextArea
          name='buildingDescription'
          value={property.buildingDescription || ""}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Building Size (SF)'
          name='buildingSize'
          number
          value={property.buildingSize}
          onChange={this.props.onChange}
        />
        { property.propertyTypeId != 5 && /* All types except land */
          <HorizontalForm.Select
            name='buildingClass'
            options={this.props.buildingClasses}
            value={property.buildingClass}
            onChange={this.props.onChange}
          />
        }
        <HorizontalForm.TextInput
          label='Occupancy %'
          name='occupancyPct'
          number
          value={property.occupancyPct}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Vacancy %'
          name='vacancyPct'
          number
          value={property.vacancyPct}
          onChange={this.props.onChange}
        />
        <HorizontalForm.Select
          includeBlank
          label='Tenancy'
          name='tenancyId'
          options={tenancyIdOptions}
          value={property.tenancyId}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Available SF'
          name='availableSf'
          number
          value={property.availableSf}
          onChange={this.props.onChange}
        />
        { property.propertyTypeId == 3 && /* Industrial Only */
          <React.Fragment>
            <HorizontalForm.TextInput
              label='Number of Grade Level Doors'
              name='gradeLevelDoors'
              number
              value={property.gradeLevelDoors}
              onChange={this.props.onChange}
            />
            <HorizontalForm.TextInput
              label='Number of Dock High Doors'
              name='dockHighDoors'
              number
              value={property.dockHighDoors}
              onChange={this.props.onChange}
            />
            <HorizontalForm.TextInput
              label='Number of Drive in Bays'
              name='driveInBays'
              number
              value={property.driveInBays}
              onChange={this.props.onChange}
            />
            <HorizontalForm.TextInput
              name='numberOfCranes'
              number
              value={property.numberOfCranes}
              onChange={this.props.onChange}
            />
            <HorizontalForm.TextInput
              name='dockDoorDescription'
              value={property.dockDoorDescription}
              onChange={this.props.onChange}
            />
            <HorizontalForm.TextInput
              name='craneDescription'
              value={property.craneDescription}
              onChange={this.props.onChange}
            />
            <HorizontalForm.TextInput
              name='sprinklerDescription'
              value={property.sprinklerDescription}
              onChange={this.props.onChange}
            />
          </React.Fragment>
        }
        <HorizontalForm.TextInput
          label='Ceiling Height (ft)'
          name='ceilingHeight'
          number
          value={property.ceilingHeight}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Minimum Ceiling Height (ft)'
          name='ceilingHeightMin'
          number
          value={property.ceilingHeightMin}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Office Space (SF)'
          name='industrialOfficeSpace'
          number
          value={property.industrialOfficeSpace}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Number of Floors'
          name='stories'
          number
          value={property.stories}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Average Floor Size (SF)'
          name='typicalFloorSize'
          number
          value={property.typicalFloorSize}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='yearBuilt'
          number
          value={property.yearBuilt}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Year Last Renovated'
          name='renovated'
          number
          value={property.renovated}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='numberOfUnits'
          number
          value={property.numberOfUnits}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label="Column Space X (ft)"
          name="columnSpaceX"
          number
          value={property.columnSpaceX}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label="Column Space Y (ft)"
          name="columnSpaceY"
          number
          value={property.columnSpaceY}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          name='numberOfParkingSpaces'
          number
          value={property.numberOfParkingSpaces}
          onChange={this.props.onChange}
        />
        <HorizontalForm.TextInput
          label='Parking Ratio (per 1000 SF)'
          name='parkingRatio'
          number
          value={property.parkingRatio}
          onChange={this.props.onChange}
        />
        <div
          className='btn btn-light mt-4 w-100'
          name='building-info-toggle'
          onClick={this.toggleExpand}
        >
          {`${this.state.expanded ? "Hide" : "Show"} Additional Fields`}
        </div>
        {this.renderAdditionalFields()}
      </React.Fragment>
    );
  }
}
